import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useUsuarioService } from "@services/UsuarioService";
import { useThemeColor } from "@themes/Colors";
import { KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";

export enum EnumUsuarioStatus {
    None = "0",
    Ativo = 1,
    Inativo = 2
}
export default interface IUsuarioStatus {
    usuarioStatusId: number,
    nome: string,
    ativo: string,
}

export type IComboUsuarioStatus = ISpecializedCombo<IUsuarioStatus>;

export function useUsuarioStatusCombo (initialValue?: EnumUsuarioStatus) : IComboUsuarioStatus {
    const combo = useCombo<IUsuarioStatus>({
        value: initialValue
    });

    const usuarioService = useUsuarioService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((usuarioStatus, index) => {
            return <MenuItem key={index} value={usuarioStatus.usuarioStatusId}>{params?.prefix}{usuarioStatus.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IUsuarioStatus>) => {
        combo.load(usuarioService.listarStatusAtivos, afterLoad)
    }, [combo, usuarioService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useUsuarioStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumUsuarioStatus, string> = React.useMemo(() => ({
        [EnumUsuarioStatus.None]: "",
        [EnumUsuarioStatus.Ativo]: themeColor.status.verde,
        [EnumUsuarioStatus.Inativo]: themeColor.status.cinza,
    }), [themeColor.status.cinza, themeColor.status.verde]);

    return React.useMemo(() => map, [map]);
}